import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=9bf79710&scoped=true"
import script from "./addModel.vue?vue&type=script&lang=js"
export * from "./addModel.vue?vue&type=script&lang=js"
import style0 from "./addModel.vue?vue&type=style&index=0&id=9bf79710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf79710",
  null
  
)

export default component.exports